import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToPageTarget } from "@/shared/utils/scrollToPageTarget";

export function RouteScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      const root = document.documentElement;
      const previousScrollBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = "auto";

      if (hash) {
        scrollToPageTarget(hash);
      } else {
        window.scrollTo({ top: 0, left: 0 });
      }

      root.style.scrollBehavior = previousScrollBehavior;
    });

    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
}
